export default __webpack_public_path__ + "static/media/PPAita.e6b322ff.pdf";